module.exports = __webpack_public_path__ + "media/audios/parent/lesson_8/audio4-041096de91ac6d84290618eb364b78c3.m4a";